import React, {
    Fragment,
    useEffect,
    useState,
    useCallback,
    useMemo,
} from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { checkResStatusService } from '../../../../utilities/ResServiceUtils';
import {
    convertDateDisplay,
    formatDate,
} from '../../../../utilities/DatetimeUtils';
import {
    PERMISSION_ORG,
    SUB_FUNCTION,
} from '../../../../constants/APDConstants';
import * as AlertMSGConstants from '../../../../constants/AlertMSGConstants';
import Loading from '../../../../control/loading/Loading';
import AlertMessage from '../../../../control/alert/AlertMessage';
import DataTable from '../../../../control/table/DataTable';
import GetAppIcon from '@material-ui/icons/GetApp';
import SearchForm from './SearchForm';
import { change, getFormValues, reset } from 'redux-form';
import moment from 'moment';
import {
    useHistory,
    useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import CustomButton from '../../../../control/button/Button';
import ModalRegisterDetail from './ModalRegisterDetail';
import * as ApiEvent from '../../../../api/ApiEvent';
import {
    EVENT_STATUS,
    formatDisplayNumber,
    optionAttendeeType,
    optionRegisterType,
} from '../../FormUtils';
import ModalRegisterEvent from './ModalRegisterEvent';
import ControlButton from '../../../../control/button/Button';
import * as dayjs from 'dayjs';

const columns = [
    {
        title: 'ประเภทผู้เข้าร่วมกิจกรรม',
        data: 'registerType',
        align: 'left',
        sort: true,
        width: '10%',
    },
    {
        title: 'รหัสพนักงาน',
        data: 'empId',
        sort: true,
        width: '7%',
    },
    {
        title: 'ชื่อ - นามสกุล',
        data: 'fullName',
        sort: true,
        width: '10%',
    },
    {
        title: 'อีเมล',
        data: 'email',
        type: 'number',
        sort: true,
        width: '12%',
    },
    {
        title: 'ตำแหน่งงาน',
        data: 'position',
        sort: true,
        width: '8%',
    },
    {
        title: 'ฝ่าย',
        data: 'department',
        sort: true,
        width: '8%',
    },
    {
        title: 'วัน/เวลาที่ลงทะเบียนล่วงหน้า',
        data: 'reserveAt',
        sort: true,
        type: 'date',
        width: '10%',
    },
    {
        title: 'วัน/เวลาที่ลงทะเบียนเข้าร่วมกิจกรรม',
        data: 'checkinAt',
        sort: true,
        width: '12%',
    },
    {
        title: 'ประเภทการเข้าร่วมกิจกรรม',
        data: 'checkinType',
        sort: true,
        width: '10%',
    },
    {
        title: 'ช่องทางการลงทะเบียนเข้าร่วมกิจกรรม',
        data: 'channel',
        sort: true,
        width: '13%',
    },
];

const useStyles = makeStyles((theme) => ({
    rootPaper: {
        padding: '24px 36px 24px 12px',
    },
    form: {
        marginTop: theme.spacing(2),
    },
    divider: {
        width: '100%',
        margin: '24px 0px',
    },
    result: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '20px',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-start',
            paddingTop: '8px',
            paddingBottom: '8px',
        },
    },
    buttonExportAll: {
        height: '40px',
        marginBottom: '5px',
        padding: '0px',
        marginLeft: '10px',
        paddingRight: '10px',
        paddingLeft: '10px',
        backgroundColor: '#016f01',
        color: '#FFFFFF',
        '&:active': {
            backgroundColor: '#016f01',
        },
        '&:hover': {
            backgroundColor: '#016f01',
        },
        '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
        },
    },

    btnCloseModal: {
        backgroundColor: `${theme.mainTheme.color6} !important`,
    },
    tableControl: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
    },
    title: {
        fontSize: '33px',
        fontWeight: '400',
        paddingLeft: '8px',
    },
    summaryContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        padding: '44px 24px 44px 24px',
        borderRadius: '12px',
        width: '100%',
        border: '1px solid #00000024',
        marginBottom: '60px',
        marginTop: '20px',
        '& svg': {
            margin: theme.spacing(1.5),
        },
        '& hr': {
            margin: theme.spacing(0, 0.5),
        },
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
        },
        alignItems: 'stretch',
    },
    summaryCategoryContainer: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '173px',
    },
    summaryText: {
        fontSize: '24px',
        fontWeight: '500',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        gap: '20px',
    },
    numberSummaryText: {
        fontSize: '36px',
        fontWeight: '700 !important',
        color: theme.mainTheme.color1,
        textAlign: 'center',
    },
    dividerVertical: {
        height: '24px',
        alignSelf: 'center',
        backgroundColor: '#B1B1B1',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    dataTable: {
        '& #pagination-container': {
            maxHeight: '56px',
            '& .MuiTypography-root': {
                marginBottom: 0,
            },
        },
    },
    btnBack: {
        backgroundColor: '#808080 !important',
        width: '244px',
        maxWidth: '244px',
        height: '40px',
    },
    controlBtnContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '36px',
    },
    walkinBtn: {
        textTransform: 'none',
    },
}));

const defaultValues = {
    keyword: null, //ชื่อกิจกรรม
    registerType: null, //สถานที่จัดกิจกรรม
    isInternal: null, //ประเภทผู้เข้าร่วมกิจกรรม
    company: null, //หน่วยงาน
    pathId: null, //สายงาน
    depId: null, //ฝ่าย
};

const formId = 'EventDetailSearchForm';
const modalFormId = 'ModalRegisterEventForm';

const formatEventDateTime = (date) => {
    const dateObj = new Date(date);
    if (!isNaN(dateObj.getTime())) {
        return (
            convertDateDisplay(formatDate(dateObj)) +
            ' ' +
            moment(date).format('HH:mm น.')
        );
    } else {
        return '-';
    }
};

const EventDetailParticipant = ({ authenRdc, ...props }) => {
    const { alertMessageState, eventData, setEventData, loadingState } = props;
    const history = useHistory();
    const values = useSelector((state) => getFormValues(formId)(state));
    const classes = useStyles();
    const dispatch = useDispatch();
    const { eventId } = useParams();

    const [lookups, setLookups] = useState({
        registerType: [],
        attendeeType: [],
        company: [],
        paths: [],
        departments: [],
    });

    const [initialDep, setInitialDep] = useState([]);

    const [tableConfig, setTableConfig] = useState({
        currentPage: 1,
        pageSize: 10,
        sortField: null,
        sortOrder: null,
        total: 0,
    });
    const [filters, setFilters] = useState({ ...defaultValues });
    const [results, setResults] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [infoCurrentRow, setInfoCurrentRow] = useState(null);

    const isCheckedInAvailable = useMemo(() => {
        const now = dayjs();
        const checkInOpenDateTime = dayjs(eventData.checkInOpenDateTime);

        if (!now.isBefore(checkInOpenDateTime)) {
            return true;
        }
        return false;
    }, [eventData]);

    const isEventOver = useMemo(() => {
        const now = dayjs();
        const eventEndDateTime = dayjs(
            `${eventData.eventEndDate} ${eventData.eventEndTime}`,
            'YYYY-MM-DD HH:mm'
        );
        return now.isAfter(eventEndDateTime);
    }, [eventData]);

    // admin, ผู้สร้างกิจกรรม, ผู้จัด (mainCoordinator), ผู้ช่วยจัด (coordinators)
    const canManageReserve = useMemo(() => {
        if (!eventData) {
            return false;
        }
        const { uuid, subFunctions } = authenRdc.profile;
        const isAdmin = subFunctions.some(
            (fn) => fn.subFunctionId === SUB_FUNCTION.EVENT_ADMIN
        );
        const isCreator = eventData.createdBy === uuid;
        const isMainCoordinator =
            !!eventData.mainCoordinator &&
            eventData.mainCoordinator.userId === uuid;
        const isCoordinator =
            Array.isArray(eventData.coordinators) &&
            eventData.coordinators.some((coord) => coord.userId === uuid);
        return isAdmin || isCreator || isMainCoordinator || isCoordinator;
    }, [eventData, authenRdc]);

    // กิจกรรมไม่ถูกยกเลิก และยังไม่ถึงวันที่/เวลาเริ่มต้นกิจกรรม
    const isCancelReserveAvailable = useMemo(() => {
        if (!eventData) {
            return false;
        }
        const isCancelled =
            String(eventData.statusId) === EVENT_STATUS.CANCELLED;
        const eventStartDateTime = dayjs(
            `${eventData.eventStartDate} ${eventData.eventStartTime}`,
            'YYYY-MM-DD HH:mm'
        );
        return !isCancelled && dayjs().isBefore(eventStartDateTime);
    }, [eventData]);

    const canCancelReserve = useCallback(
        (row) =>
            !!row &&
            !!row.reserveId &&
            !row.isCheckedIn &&
            canManageReserve &&
            isCancelReserveAvailable,
        [canManageReserve, isCancelReserveAvailable]
    );

    const tableData = useMemo(
        () =>
            results.map((row) => ({
                ...row,
                delete: canCancelReserve(row),
            })),
        [results, canCancelReserve]
    );

    const handleClickBack = useCallback(() => {
        history.push(`/event`);
    }, [history]);

    const getLookups = useCallback(async () => {
        loadingState.showLoading();
        try {
            // Get Lookup for AutoComplete Fields here
            const res = await Promise.all([
                ApiEvent.getLookupEventDetail('company'),
                ApiEvent.getLookupEventDetail('paths'),
                ApiEvent.getLookupEventDetail('departments'),
            ]);
            setLookups({
                registerType: optionRegisterType,
                attendeeType: optionAttendeeType,
                company: res[0].data,
                paths: res[1].data,
                departments: [],
            });
            setInitialDep(res[2].data);
            loadingState.hideLoading();
        } catch (error) {
            loadingState.hideLoading();
            alertMessageState.showAlert({
                altMsg: AlertMSGConstants.SYSTEM_ERROR,
            });
        }
    }, [loadingState, alertMessageState]);

    const handleChangePath = useCallback(
        async (value) => {
            if (value) {
                const newDep = initialDep.filter((dep) => dep.pathId !== value);
                setLookups((prev) => ({ ...prev, departments: newDep }));
            } else if (!value) {
                setLookups((prev) => ({ ...prev, departments: [] }));
            }
            dispatch(change(formId, 'pathId', value));
            dispatch(change(formId, 'depId', null));
        },
        [initialDep, dispatch]
    );

    const fetchData = useCallback(
        async (newTableConfig = {}, newFilters = {}) => {
            loadingState.showLoading();
            let parameters;
            if (newFilters === null) {
                setFilters({ ...defaultValues });
                parameters = {
                    ...tableConfig,
                    ...newTableConfig,
                    ...defaultValues,
                };
            } else {
                setFilters({
                    ...filters,
                    ...newFilters,
                });
                parameters = {
                    ...tableConfig,
                    ...newTableConfig,
                    ...filters,
                    ...newFilters,
                };
            }
            delete parameters.total;
            try {
                const [response, eventDetailResponse] = await Promise.all([
                    ApiEvent.getEventCheckinUser(eventId, parameters),
                    ApiEvent.fetchEventById(eventId, {
                        userId: authenRdc.profile.uuid,
                    }),
                ]);
                // fetchData to service event here
                loadingState.hideLoading();
                if (eventDetailResponse.data) {
                    setEventData(eventDetailResponse.data);
                } else {
                    alertMessageState.showAlert({
                        altMsg:
                            checkResStatusService(response) ||
                            AlertMSGConstants.SYSTEM_ERROR,
                    });
                }
                if (response.data.items) {
                    const startIndex =
                        parameters.pageSize * (parameters.currentPage - 1) + 1;
                    setResults(
                        response.data.items.map((item, index) => ({
                            ...item,
                            detail: true,
                            index: startIndex + index,
                            isCheckedIn: !!item.checkinAt,
                            reserveAt: item.reserveAt
                                ? formatEventDateTime(item.reserveAt)
                                : '-',
                            checkinAt: item.checkinAt
                                ? formatEventDateTime(item.checkinAt)
                                : '-',
                            fullName: item.firstName + ' ' + item.lastName,
                            registerType: item.isInternal
                                ? 'พนักงานและลูกจ้างพนักงาน'
                                : 'บุคลากรภายนอก',
                            department: item.org ? item.org.depShortName : '-',
                            position: item.isInternal
                                ? item.job.jobShortName
                                : item.position,
                        }))
                    );
                    setTableConfig((prev) => ({
                        ...prev,
                        ...newTableConfig,
                        total: response.data.total,
                    }));
                } else {
                    alertMessageState.showAlert({
                        altMsg:
                            checkResStatusService(response) ||
                            AlertMSGConstants.SYSTEM_ERROR,
                    });
                }
            } catch (error) {
                loadingState.hideLoading();
                alertMessageState.showAlert({
                    altMsg: AlertMSGConstants.SYSTEM_ERROR,
                });
            }
        },
        [alertMessageState, filters, loadingState, tableConfig, eventId]
    );

    const exportData = useCallback(
        async (newTableConfig = {}, newFilters = {}) => {
            loadingState.showLoading();
            setFilters({
                ...filters,
                ...newFilters,
            });
            const parameters = {
                ...tableConfig,
                ...newTableConfig,
                ...filters,
                ...newFilters,
            };
            delete parameters.total;
            delete parameters.pageSize;
            delete parameters.currentPage;
            try {
                const response = await ApiEvent.exportEventCheckinSearch(
                    eventId,
                    parameters
                );
                loadingState.hideLoading();
                if (response) {
                    const url = window.URL.createObjectURL(response);
                    const link = document.createElement('a');
                    link.href = url;

                    link.setAttribute(
                        'download',
                        'รายชื่อลงทะเบียนกิจกรรม.xlsx'
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } else {
                    alertMessageState.showAlert({
                        altMsg:
                            // checkResStatusService(response) ||
                            AlertMSGConstants.SYSTEM_ERROR,
                    });
                }
                loadingState.hideLoading();
            } catch (error) {
                loadingState.hideLoading();
                alertMessageState.showAlert({
                    altMsg: AlertMSGConstants.SYSTEM_ERROR,
                });
            }
        },
        [alertMessageState, eventId, filters, loadingState, tableConfig]
    );

    useEffect(() => {
        getLookups();
        fetchData({ currentPage: 1 });
    }, []);

    const handleClickExport = useCallback(() => {
        exportData({ ...values });
    }, [exportData, values]);

    const handleSubmitSearchForm = useCallback(
        (values) => {
            fetchData({ currentPage: 1 }, { ...values });
        },
        [fetchData]
    );

    const handleSortChange = useCallback(
        (sortField, sortOrder) => {
            fetchData({
                currentPage: 1,
                sortField,
                sortOrder,
            });
        },
        [fetchData]
    );

    const handlePageChange = useCallback(
        (currentPage) => {
            fetchData({ currentPage });
        },
        [fetchData]
    );

    const handleCancelReserve = useCallback(
        (row) => {
            alertMessageState.showAlert({
                altTitle: 'ยืนยันการยกเลิกการลงทะเบียนล่วงหน้า',
                altMsg: `คุณต้องการยกเลิกการลงทะเบียนล่วงหน้าของ ${row.fullName} ใช่หรือไม่`,
                altType: 2,
                callbackCancel: () => alertMessageState.hideAlert(),
                callbackConfirm: async () => {
                    alertMessageState.hideAlert();
                    loadingState.showLoading();
                    try {
                        await ApiEvent.putEventReserveCancel(
                            eventId,
                            row.reserveId,
                            { cancelBy: authenRdc.profile.uuid }
                        );
                        loadingState.hideLoading();
                        setInfoCurrentRow(null);
                        alertMessageState.showAlert({
                            altMsg: 'ยกเลิกการลงทะเบียนล่วงหน้าสำเร็จ',
                            callbackCancel: () => {
                                alertMessageState.hideAlert();
                                fetchData();
                            },
                        });
                    } catch (error) {
                        loadingState.hideLoading();
                        let altMsg = AlertMSGConstants.SYSTEM_ERROR;
                        if (
                            error &&
                            Array.isArray(error.errors) &&
                            error.errors[0]
                        ) {
                            altMsg =
                                error.errors[0].detail ||
                                error.errors[0].title ||
                                altMsg;
                        }
                        alertMessageState.showAlert({ altMsg });
                    }
                },
            });
        },
        [alertMessageState, loadingState, eventId, authenRdc, fetchData]
    );

    const handleRowClick = useCallback(
        (item, mode) => {
            if (mode === 'delete') {
                handleCancelReserve(item);
            } else {
                // open modal to each record// can view details or register
                setInfoCurrentRow(item);
            }
        },
        [handleCancelReserve]
    );

    const handleCloseInfoModal = useCallback(() => {
        setInfoCurrentRow(null);
    }, []);

    const handleToggleModal = useCallback(() => {
        setIsOpen((prev) => !prev);
        dispatch(reset(modalFormId));
    }, [dispatch]);

    const handleRegisterEventInternalExternal = useCallback(
        async (formValues, isRow) => {
            try {
                loadingState.showLoading();
                let res;
                if (formValues.isInternal === true) {
                    // register post internal
                    res = await ApiEvent.postCheckinEventInternal(
                        eventData.eventId,
                        {
                            actionBy: authenRdc.profile.uuid,
                            empId: formValues.empIdSelected,
                        }
                    );
                } else if (formValues.isInternal === false) {
                    // register post external
                    res = await ApiEvent.postCheckinEventExternal(
                        eventData.eventId,
                        {
                            actionBy: authenRdc.profile.uuid,
                            email: formValues.email,
                            firstName: formValues.firstName,
                            lastName: formValues.lastName,
                            companyName: formValues.companyName,
                            position: formValues.position,
                        }
                    );
                }
                if (res.data.checkinId) {
                    alertMessageState.showAlert({
                        altMsg: 'ลงทะเบียนเข้างานสำเร็จ',
                        callbackCancel: () => {
                            if (isOpen) {
                                setIsOpen(false);
                                dispatch(reset(modalFormId));
                            } else {
                                setInfoCurrentRow(null);
                            }
                            alertMessageState.hideAlert();
                        },
                    });
                }
                loadingState.hideLoading();
            } catch (error) {
                loadingState.hideLoading();
                let altMsg = AlertMSGConstants.SYSTEM_ERROR;

                if (error && Array.isArray(error.errors) && error.errors[0]) {
                    if (error.errors[0].detail) {
                        altMsg = error.errors[0].detail;
                    } else if (error.errors[0].title) {
                        altMsg = error.errors[0].title;
                    }
                }

                alertMessageState.showAlert({ altMsg });
            }
        },
        [
            authenRdc,
            eventData,
            loadingState,
            alertMessageState,
            dispatch,
            isOpen,
        ]
    );

    const onSubmitRegisterEvent = useCallback(
        async (formValues, isRow = false) => {
            alertMessageState.showAlert({
                altTitle: 'ยืนยันการลงทะเบียนเข้างาน',
                altMsg: 'คุณต้องการยืนยันการลงทะเบียนเข้างานใช่หรือไม่',
                altType: 2,
                callbackCancel: () => alertMessageState.hideAlert(),
                callbackConfirm: async () => {
                    alertMessageState.hideAlert();
                    await handleRegisterEventInternalExternal(
                        formValues,
                        isRow
                    );
                    await fetchData();
                },
            });
        },
        [alertMessageState, handleRegisterEventInternalExternal, fetchData]
    );

    const handleRegister = useCallback(
        async (rowData) => {
            await onSubmitRegisterEvent(rowData, true);
            // register per rowData
        },
        [onSubmitRegisterEvent]
    );

    const handleClickReset = useCallback(async () => {
        dispatch(reset(formId));
        setFilters({ ...defaultValues });
        await fetchData(
            { currentPage: 1, sortField: null, sortOrder: null },
            null
        );
    }, [fetchData, dispatch]);

    return (
        <Fragment>
            <Grid container className={classes.rootPaper}>
                <div className={classes.title}>ข้อมูลผู้ลงทะเบียนกิจกรรม</div>
                <Grid item xs={12} className={classes.form}>
                    <SearchForm
                        defaultValues={defaultValues}
                        lookups={lookups}
                        showOrganization={
                            authenRdc.profile.permissionOrgId !==
                            PERMISSION_ORG.PERSONAL_ORG
                        }
                        onSubmit={handleSubmitSearchForm}
                        handleChangePath={handleChangePath}
                        handleClickReset={handleClickReset}
                    />
                </Grid>
                <Grid item xs={12} className={classes.divider}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" component="span">
                        สรุปจำนวนผู้ลงทะเบียนกิจกรรม
                    </Typography>
                    <div className={classes.summaryContainer}>
                        <div className={classes.summaryCategoryContainer}>
                            <div className={classes.summaryText}>
                                ลงทะเบียนผ่านไฟล์รายชื่อ
                            </div>
                            <span className={classes.numberSummaryText}>
                                {eventData && eventData.importedReservedCount
                                    ? formatDisplayNumber(
                                          eventData.importedReservedCount
                                      )
                                    : 0}
                            </span>
                        </div>
                        <Divider
                            orientation="vertical"
                            flexItem
                            className={classes.dividerVertical}
                        />
                        <div className={classes.summaryCategoryContainer}>
                            <div className={classes.summaryText}>
                                ลงทะเบียนด้วยตัวเอง
                            </div>
                            <span className={classes.numberSummaryText}>
                                {eventData && eventData.normalReservedCount
                                    ? formatDisplayNumber(
                                          eventData.normalReservedCount
                                      )
                                    : 0}
                            </span>
                        </div>
                        <Divider
                            orientation="vertical"
                            flexItem
                            className={classes.dividerVertical}
                        />
                        <div className={classes.summaryCategoryContainer}>
                            <div className={classes.summaryText}>
                                ลงทะเบียนเข้างาน
                            </div>
                            <span className={classes.numberSummaryText}>
                                {eventData && eventData.checkInCount
                                    ? formatDisplayNumber(
                                          eventData.checkInCount
                                      )
                                    : 0}
                            </span>
                        </div>
                        <Divider
                            orientation="vertical"
                            flexItem
                            className={classes.dividerVertical}
                        />
                        <div className={classes.summaryCategoryContainer}>
                            <div className={classes.summaryText}>
                                โควต้าที่กำหนด
                            </div>
                            <span className={classes.numberSummaryText}>
                                {eventData && eventData.totalCapacity
                                    ? formatDisplayNumber(
                                          eventData.totalCapacity
                                      )
                                    : 0}
                            </span>
                        </div>
                        <Divider
                            orientation="vertical"
                            flexItem
                            className={classes.dividerVertical}
                        />
                        <div className={classes.summaryCategoryContainer}>
                            <div className={classes.summaryText}>
                                ผู้บันทึกกิจกรรม
                            </div>
                            <span className={classes.numberSummaryText}>
                                {eventData && eventData.favoriteCount
                                    ? formatDisplayNumber(
                                          eventData.favoriteCount
                                      )
                                    : 0}
                            </span>
                        </div>
                    </div>
                </Grid>
                <Grid item className={classes.tableControl}>
                    <div>
                        <Typography variant="h5" component="span">
                            รายชื่อผู้ลงทะเบียนกิจกรรม
                        </Typography>
                        <Button
                            variant="contained"
                            className={classes.buttonExportAll}
                            startIcon={<GetAppIcon />}
                            onClick={handleClickExport}
                            disabled={
                                loadingState.isShowLoading ||
                                results.length === 0
                            }
                        >
                            ออกรายงาน EXCEL
                        </Button>
                    </div>
                    <div className={classes.result}>
                        <div>พบผลลัพธ์ทั้งหมด {tableConfig.total} รายการ</div>
                        {eventData && eventData.isRequiredCheckin && (
                            <CustomButton
                                label="ลงทะเบียน Walk-in"
                                onClick={handleToggleModal}
                                disabled={!isCheckedInAvailable || isEventOver}
                                className={classes.walkinBtn}
                            />
                        )}
                    </div>
                </Grid>
                <Grid item xs={12} className={classes.dataTable}>
                    <DataTable
                        column={columns}
                        rowPerPage={tableConfig.pageSize}
                        notSort={true}
                        page={tableConfig.currentPage}
                        data={tableData}
                        total={tableConfig.total}
                        sortColumn={tableConfig.sortField}
                        sortType={tableConfig.sortOrder}
                        handleSortExternal={handleSortChange}
                        handlePageChange={handlePageChange}
                        handleRowClick={handleRowClick}
                        minWidth="2000px"
                        labelBtnDelete="ยกเลิก"
                    />
                </Grid>
                <Grid item xs={12} className={classes.controlBtnContainer}>
                    <ControlButton
                        label="กลับไปหน้าจัดการกิจกรรม"
                        className={classes.btnBack}
                        onClick={handleClickBack}
                    />
                </Grid>
            </Grid>
            <AlertMessage {...alertMessageState.altProps} />
            <Loading isShowLoading={loadingState.isShowLoading} />
            <ModalRegisterDetail
                infoCurrentRow={infoCurrentRow}
                handleCloseInfoModal={handleCloseInfoModal}
                handleRegister={handleRegister}
                eventData={eventData}
                isEventOver={isEventOver}
                canCancelReserve={canCancelReserve(infoCurrentRow)}
                handleCancelReserve={handleCancelReserve}
            />
            {eventData && (
                <ModalRegisterEvent
                    open={isOpen}
                    onClose={handleToggleModal}
                    eventId={eventData.eventId}
                    onSubmit={onSubmitRegisterEvent}
                />
            )}
        </Fragment>
    );
};

export default connect((state) => ({
    authenRdc: state.authen,
}))(EventDetailParticipant);
